import { useQuery } from "@tanstack/react-query";
import React from "react";
import styled from "styled-components";
import { getSuppliers } from "../../../services/filamentService";
import Table from "../../components/core-components/Table.tsx";
import Button from "../../components/core-components/Button.tsx";
import Modal from "../../components/core-components/Modal.tsx";
import AddSupplierComponent from "../../components/core-components/AddSupplierComponent.tsx";
import { toast, ToastContainer } from "react-toastify";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;
const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding-bottom: 0.5rem;
`;
const PageTitle = styled.h2`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  letter-spacing: 1px;
`;
interface Props {}

const notify = () =>
  toast.success("Furnizor adăugat cu succes !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });

const notifyError = () =>
  toast.error("Furnizorul nu s-a putut adăuga !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });
const SuppliersPage: React.FC<Props> = ({}) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const { data: suppliers, refetch } = useQuery({
    queryKey: ["suppliers"],
    queryFn: () => getSuppliers(),
  });

  return (
    <Wrapper>
      <Header>
        <PageTitle>Furnizori</PageTitle>
        <Button
          id="add-supplier"
          onClick={() => setModalOpen(true)}
          text={"Adaugă furnizor"}
          backgroundColor={"white"}
          outline="var(--secondary-green)"
          color="var(--secondary-green)"
        />
      </Header>

      <Table
        columns={[
          { title: "ID", key: "supplierID" },
          { title: "Nume", key: "supplierName" },
          { title: "Telefon", key: "phoneNumber" },
          { title: "Email", key: "email" },
          { title: "Greutate rolă", key: "spoolWeight" },
        ]}
        rows={suppliers || []}
      />

      {isModalOpen && (
        <Modal
          name="add-supplier-modal"
          title={"Adaugă furnizor"}
          onClose={() => setModalOpen(false)}
          content={
            <AddSupplierComponent
              closeAddMode={(result) => {
                setModalOpen(false);
                if (result === "success") {
                  notify();
                  refetch();
                } else if (result === "error") {
                  notifyError();
                }
              }}
            />
          }
        />
      )}
      <ToastContainer />
    </Wrapper>
  );
};

export default SuppliersPage;
